import { useMutation, useQuery } from "@apollo/client";
import {
  ADD_FINANCIAL_INFORMATION_MUTATION,
  GET_FINANCIAL_INFORMATION,
  UPDATE_FINANCIAL_INFORMATION_MUTATION,
} from "../graphQl/FinancialInformationAPI";

// `skip` (options) : à passer à true quand financialInformationId vient
// d'être obtenu localement (mutation MT_ADD_FINANCIAL_INFORMATION déjà en
// main, donc déjà dans le formulaire) plutôt que chargé depuis une route
// d'édition — évite un QR_GET_FINANCIAL_INFORMATION redondant juste après la
// création.
export const useFinancialInformationData = (
  establishmentId,
  financialInformationId,
  { skip: extraSkip = false } = {}
) => {
  const { data, loading, error } = useQuery(GET_FINANCIAL_INFORMATION, {
    variables: { establishmentId, financialInformationId },
    skip: !establishmentId || !financialInformationId || extraSkip,
    fetchPolicy: "cache-and-network",
  });

  return {
    financialInformation: data?.QR_GET_FINANCIAL_INFORMATION?.data || null,
    loading,
    error,
  };
};

export const useFinancialInformation = () => {
  const [addMutation, { loading: isAdding }] = useMutation(
    ADD_FINANCIAL_INFORMATION_MUTATION
  );
  const [updateMutation, { loading: isUpdating }] = useMutation(
    UPDATE_FINANCIAL_INFORMATION_MUTATION
  );

  const addFinancialInformation = (establishmentId, financialInformationInput) =>
    addMutation({ variables: { establishmentId, financialInformationInput } });

  const updateFinancialInformation = (
    establishmentId,
    financialInformationId,
    financialInformationInput
  ) =>
    updateMutation({
      variables: { establishmentId, financialInformationId, financialInformationInput },
    });

  return {
    addFinancialInformation,
    updateFinancialInformation,
    loading: isAdding || isUpdating,
  };
};
